<template>
  <section class="signup-form signup content">
    <div class="container">
      <div class="row form-row">
        <div class="col-sm-6">
          <div class="form-left">
            <div class="inner-logo"><img src="../assets/images/logo.png" alt="" /></div>
            <div class="form-pic hidden-xs">
              <img src="../assets/images/formpic.jpg" alt="" />
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-main">
            <h2 class="">注册账号 <span>>></span></h2>
            <form method="post">
              <div class="row-box">
                <div class="col-box">
                  <input
                    v-model="phone"
                    type="tel"
                    name="phone_number"
                    maxlength="11"
                    class=""
                    pattern="[0-9\+\(\})]+"
                    id="id_phone_number"
                    placeholder="请输入手机号"
                  />
                </div>
              </div>
              <div class="row-box">
                <div class="col-box">
                  <input
                    type="password"
                    name="business_name"
                    maxlength="60"
                    required=""
                    class=""
                    v-model="password"
                    id="id_business_name"
                    placeholder="请输入密码"
                  />
                </div>
              </div>
              <div class="row-box">
                <div class="col-box">
                  <input
                    type="password"
                    maxlength="60"
                    class=""
                    placeholder="请确认密码"
                    v-model="confirm_password"
                    id="id_business_website"
                  />
                </div>
              </div>
              <div class="row-box">
                <div class="col-box">
                  <input
                    type="text"
                    class=""
                    maxlength="6"
                    v-model="verifyCode"
                    placeholder="图片验证码"
                  />
                  <img
                    id="verifyCode"
                    style=""
                    :src="this._Global.HTTP_SERVER + '/register/verficationCode'"
                    @click="verifyCodeRefresh"
                    onmouseover="this.style.cursor='pointer'"
                  />
                </div>
              </div>
              <div class="row-box">
                <div class="col-box">
                  <input
                    type="text"
                    placeholder="短信验证码"
                    class=""
                    maxlength="6"
                    v-model="smsCode"
                  />
                  <button
                    id="btn_send_sms"
                    @click="sendSmsCode(120)"
                    type="button"
                    class="btn-getcode"
                  >
                    获取验证码
                  </button>
                </div>
              </div>
              <p></p>
              <div class="login--form--submit">
                <button
                  @click="register"
                  style="width: 6em"
                  class="btn btn-success"
                  type="button"
                >
                  注册
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
var self;
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      phone: "",
      password: "",
      confirm_password: "",
      smsCode: "",
      verifyCode: "",
      verifyCodeRefreshTime: 600,
      verifyCodeKey: null,
    };
  },
  mounted() {
    self = this;
    this.verifyCodeTimeRefresh(this.verifyCodeRefreshTime);
    this.verifyCodeRefresh();
  },
  methods: {
    register: function () {
      if (
        this.phone == null ||
        this.phone == "" ||
        this.password == null ||
        this.password == "" ||
        this.smsCode == "" ||
        this.verifyCode == ""
      ) {
        this.errToastr("账号、密码、图片验证码、短信验证码不能为空");
        return;
      }

      if (this.confirm_password != this.password) {
        this.errToastr("密码和确认密码不一致");
        return;
      }

      if (!this.isPhoneNum(this.phone)) {
        this.errToastr("请填写正确的手机号");
        return;
      }
      this.$http
        .post(this._Global.HTTP_SERVER + "/register", {
          account: this.phone,
          password: this.password,
          smsCode: this.smsCode,
          verifyCode: this.verifyCode,
          verifyCodeKey: this.verifyCodeKey,
        })
        .then((response) => {
          self.respDataHandle(response.body, function (respData) {
            self.setToken(respData);
            self.$router.push({ name: "SuperSign" });
          });
        });
    },
    sendSmsCode: function (seconds) {
      if (this.phone == "" || this.verifyCode == "") {
        this.errToastr("手机号或图片验证码不能为空");
        return;
      }

      this.$http
        .post(this._Global.HTTP_SERVER + "/register/sms_code", {
          phone: this.phone,
          verifyCode: this.verifyCode,
          verifyCodeKey: this.verifyCodeKey,
        })
        .then((response) => {
          self.respDataHandle(
            response.body,
            function (respData) {
              console.log("tag", respData);
              if (respData) {
                $("#btn_send_sms").text("获取验证码 " + seconds + "s");
                $("#btn_send_sms").attr("disabled", true);
                self.timeRefresh(seconds);
              }
            },
            function () {
              self.verifyCodeRefresh();
            }
          );
        });
    },
    timeRefresh: function (seconds) {
      setTimeout(function () {
        seconds--;
        if (seconds > 0) {
          console.log("tag", seconds);
          $("#btn_send_sms").text("获取验证码 " + seconds + "s");
          $("#btn_send_sms").attr("disabled", true);
          self.timeRefresh(seconds);
        } else {
          $("#btn_send_sms").text("获取验证码");
          $("#btn_send_sms").attr("disabled", false);
        }
      }, 1000);
    },
    verifyCodeRefresh: function () {
      this.verifyCodeKey = new Date().getTime();
      console.log("tag", this.verifyCodeKey);
      $("#verifyCode").attr(
        "src",
        this._Global.HTTP_SERVER +
          "/register/verficationCode?verifyCodeKey=" +
          this.verifyCodeKey
      );
    },
    verifyCodeTimeRefresh: function (seconds) {
      setTimeout(function () {
        seconds--;
        if (seconds <= 0) {
          this.verifyCodeRefresh();
          seconds = self.verifyCodeRefreshTime;
        }
        console.log("verifyCodeTimeRefresh ==>", seconds);
        self.verifyCodeTimeRefresh(seconds);
      }, 1000);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Register.vue